import { getApi, postApi } from './utils';

import { abbrNum } from '@blueberry/utils/decimalParser';
import { abbrivationFormat } from '@blueberry/utils/datetime';

const getManagingUrl = url => `contents/api/browsing/${url}`;
const getRecordingUrl = url => `contents/api/recording/${url}`;

export const getPage = ({ name, region }) =>
  getApi(getManagingUrl(`v1/pages/${name}_${region}`));

export const getPageWithPaging = ({ name, region, page, limit }) =>
  getApi(
    getManagingUrl(`v1/pages/${name}_${region}?page=${page}&limit=${limit}`)
  );

export const getBanner = ({ region }) =>
  getApi('api/v2/web/banners', {
    params: {
      region_name: region,
      for_content_page: 'true',
    },
  });

export const getPost = ({ id }) => getApi(getManagingUrl(`v1/posts/${id}`));
export const getAuthorAvatar = ({ id }) => getApi(`api/v3/authors/${id}`);

export const postRecordEvent = ({ id, eventType }) =>
  postApi(getRecordingUrl(`v1/posts/${id}?event_type=${eventType}`));

export const getRecentlyPost = () =>
  getApi(getRecordingUrl('v1/recently_viewed_records'));

export const getLatestPost = params =>
  getApi(getManagingUrl('v1/specific_posts'), {
    params: {
      query_type: 'latest',
      ...params,
    },
  });

export const getTrendPost = params =>
  getApi(getManagingUrl('v1/specific_posts'), {
    params: {
      query_type: 'viewed',
      ...params,
    },
  });

export const getTopicPost = params =>
  getApi(getManagingUrl('v1/specific_posts'), {
    params: {
      query_type: 'random',
      ...params,
    },
  });

export const getRelatedPages = name =>
  getApi(getManagingUrl(`v1/pages/${name}/related_pages`));

export const getSubjectPage = name =>
  getApi(getManagingUrl(`v1/subject_pages/${name}`));

export const getSubtopicPage = id =>
  getApi(getManagingUrl(`v1/subtopics/${id}/posts`));

export const getChannel = id => getApi(getManagingUrl(`v1/channels/${id}`));

export const transferPostObject = post => ({
  type: post.type,
  mediaUrl: post.media_url,
  teaserUrl: post.teaser_url,
  publishDate: abbrivationFormat(post.publish_at),
  authorName: post.author && post.author.user_name,
  authorIntro: post.author && post.author.introduction,
  authorId: post.author && post.author.id,
  description: post.description,
  id: post.id,
  introText: post.intro_text,
  title: post.title,
  metaDescription: post.meta_description,
  metaTitle: post.meta_title,
  durationTime: post.duration_time,
  mediaEmbedUrl: post.media_embed_url,
  mediaImageUrl: post.media_image_url,
  mediaAltText: post.media_alt_text,
  mediaId: post.media_id,
  teaserEmbedUrl: post.teaser_embed_url,
  teaserImageUrl: post.teaser_image_url,
  teaserId: post.teaser_id,
  visitCount: abbrNum(post.visit_count),
  likeCount: abbrNum(post.like_count),
  isLike: post.is_like,
  curriculumId: post.curriculum && post.curriculum.id,
  curriculumName: post.curriculum && post.curriculum.name,
  subjectId: post.subject && post.subject.id,
  subjectName: post.subject && post.subject.name,
  topicName: post.topic && post.topic.name,
  subtopicId: post.subtopic && post.subtopic.id,
  subtopicName: post.subtopic && post.subtopic.name,
  urlTitle: post.url_title,
  category: post.category,
  concepts: post.concepts,
});

export const transferPostWithoutDescription = post => ({
  ...transferPostObject(post),
  description: undefined,
});



// WEBPACK FOOTER //
// ./app/services/contents.js